import { render, staticRenderFns } from "./BemIcon.vue?vue&type=template&id=52aa84cc&lang=pug&"
import script from "./BemIcon.vue?vue&type=script&lang=js&"
export * from "./BemIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports